import axios from 'axios';
import { getAuthHeader } from '../auth';

const baseURL = process.env.REACT_APP_BACKEND_API || `https://${window.location.host}`;

const axiosService = axios.create({
    baseURL,
    withCredentials: true,
});

/**
 * @param {import('axios').AxiosResponse} response
 */
const handleSuccess = (response) => response;

/**
 * @param {import('axios').AxiosRequestConfig} request
 */
const handleRequest = (request) => {
    request.headers = getAuthHeader();
    return request;
};

/**
* @param {any} error
*/
const handleRequestError = (error) => Promise.reject(error);

const UNAUTHORIZED_RELOAD_KEY = 'unauthorizedReloadAt';
const UNAUTHORIZED_RELOAD_WINDOW = 60 * 1000;

/**
 * A 401 usually means the API refused the session (and cleared a refused cookie): this tab's user information is
 * dropped and the page reloads, so the routes read the session again instead of showing a signed-in screen that no
 * longer works. A 401 that leaves the cookie valid (an invalid AppKey, an HR-system refusal passed through) would
 * reload forever, because each load reads the same session back: within a minute of a reload the 401 is only rejected.
 * @param {any} error
 */
const handleResponseError = (error) => {
    if (error.response?.status === 401 && sessionStorage.getItem('jwtUserInfo')) {
        const lastReload = Number(sessionStorage.getItem(UNAUTHORIZED_RELOAD_KEY)) || 0;
        if (Date.now() - lastReload >= UNAUTHORIZED_RELOAD_WINDOW) {
            sessionStorage.setItem(UNAUTHORIZED_RELOAD_KEY, String(Date.now()));
            sessionStorage.removeItem('jwtUserInfo');
            sessionStorage.removeItem('jwtLifespan');
            window.location.reload();
        }
    }
    return Promise.reject(error);
};

/**
 * @param {*} error
 */
export const extractErrorMessage = (error) => error?.response?.data?.message || error.message || JSON.stringify(error);
axiosService.interceptors.request.use(handleRequest, handleRequestError);
axiosService.interceptors.response.use(handleSuccess, handleResponseError);
export default axiosService;
